import { gql } from '@apollo/client';
import { compare } from 'compare-versions';
import { useCallback } from 'react';

import { GraphQLTypes } from 'src/lib/graphqlTypes';
import { useLDFlag } from 'src/lib/launchDarkly';

export const UseNewFedNextVersionAvailableFragment = gql`
  fragment UseNewFedNextVersionAvailableFragment on GraphVariant {
    id
    latestLaunch {
      id
      buildInput {
        ... on CompositionBuildInput {
          version
        }
      }
    }
  }
`;

type Args = Pick<
  GraphQLTypes.UseNewFedNextVersionAvailableFragment,
  'latestLaunch'
>;

export const useNewFedNextVersionAvailable = () => {
  const fedNextVersion = useLDFlag('federation-next-version');

  return useCallback(
    ({ latestLaunch }: Args) => {
      const latestLaunchCompositionVersion =
        latestLaunch?.buildInput.__typename === 'CompositionBuildInput'
          ? latestLaunch.buildInput.version
          : '';

      if (latestLaunchCompositionVersion) {
        return compare(fedNextVersion, latestLaunchCompositionVersion, '>');
      }

      return false;
    },
    [fedNextVersion],
  );
};
